var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186.066,
    height: 186.067,
    viewBox: "0 0 186.066 186.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: #554586;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    className: "cls-1",
    width: 186.067,
    height: 186.067,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Etapas",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    className: "cls-3",
    d: "M78.559,78.557v-69A9.562,9.562,0,0,1,88.121-.006h88.385a9.562,9.562,0,0,1,9.562,9.562V176.5a9.562,9.562,0,0,1-9.562,9.562H9.562A9.562,9.562,0,0,1,0,176.5V88.118a9.561,9.561,0,0,1,9.562-9.561Zm9.3,98.206h88.643a.258.258,0,0,0,.258-.259V9.556a.258.258,0,0,0-.258-.259H88.121a.259.259,0,0,0-.259.259V176.763Zm-9.3-88.9h-69a.258.258,0,0,0-.259.259V176.5a.258.258,0,0,0,.259.258h69Z",
    transform: "translate(0 0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    className: "cls-3",
    d: "M291.655,317.422a9.562,9.562,0,0,0-9.562-9.562h-19.64a9.562,9.562,0,0,0-9.562,9.562V351.8a4.651,4.651,0,0,0,4.651,4.651H287a4.651,4.651,0,0,0,4.652-4.651Zm-9.3,0a.258.258,0,0,0-.258-.258h-19.64a.258.258,0,0,0-.259.258v29.722h20.157Z",
    transform: "translate(-139.96 -170.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    className: "cls-3",
    d: "M336.808,53.54a9.561,9.561,0,0,0-9.562-9.561h-9.82a9.562,9.562,0,0,0-9.562,9.561v9.822a9.562,9.562,0,0,0,9.562,9.562h9.819a9.561,9.561,0,0,0,9.562-9.562Zm-9.3,0a.258.258,0,0,0-.259-.259h-9.82a.259.259,0,0,0-.259.259v9.822a.259.259,0,0,0,.259.258h9.82a.258.258,0,0,0,.259-.258V53.541Z",
    transform: "translate(-170.384 -24.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    className: "cls-3",
    d: "M248.845,53.54a9.562,9.562,0,0,0-9.562-9.561h-9.819A9.562,9.562,0,0,0,219.9,53.54v9.822a9.562,9.562,0,0,0,9.562,9.562h9.82a9.562,9.562,0,0,0,9.561-9.562Zm-9.3,0a.259.259,0,0,0-.259-.259h-9.82a.258.258,0,0,0-.258.259v9.822a.258.258,0,0,0,.259.258h9.82a.258.258,0,0,0,.259-.258V53.541Z",
    transform: "translate(-121.702 -24.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    className: "cls-3",
    d: "M248.845,141.5a9.563,9.563,0,0,0-9.562-9.562h-9.819A9.563,9.563,0,0,0,219.9,141.5v9.82a9.562,9.562,0,0,0,9.562,9.562h9.82a9.562,9.562,0,0,0,9.561-9.562Zm-9.3,0v9.82a.259.259,0,0,1-.259.259h-9.82a.259.259,0,0,1-.259-.259V141.5a.258.258,0,0,1,.258-.259h9.82a.259.259,0,0,1,.259.259Z",
    transform: "translate(-121.702 -73.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    className: "cls-3",
    d: "M336.807,141.5a9.562,9.562,0,0,0-9.562-9.562h-9.82a9.562,9.562,0,0,0-9.562,9.562v9.82a9.561,9.561,0,0,0,9.562,9.562h9.819a9.561,9.561,0,0,0,9.562-9.562Zm-9.3,0v9.82a.259.259,0,0,1-.259.259h-9.82a.26.26,0,0,1-.259-.259V141.5a.259.259,0,0,1,.259-.259h9.82a.258.258,0,0,1,.259.259Z",
    transform: "translate(-170.384 -73.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    className: "cls-3",
    d: "M248.845,229.469a9.562,9.562,0,0,0-9.562-9.562h-9.819a9.562,9.562,0,0,0-9.562,9.562v9.819a9.562,9.562,0,0,0,9.562,9.562h9.82a9.562,9.562,0,0,0,9.561-9.562Zm-9.3,0a.259.259,0,0,0-.259-.258h-9.82a.258.258,0,0,0-.258.258v9.819a.258.258,0,0,0,.259.258h9.82a.258.258,0,0,0,.259-.258Z",
    transform: "translate(-121.702 -121.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    className: "cls-3",
    d: "M336.807,229.466a9.561,9.561,0,0,0-9.562-9.562h-9.82a9.561,9.561,0,0,0-9.562,9.562v9.819a9.562,9.562,0,0,0,9.562,9.562h9.819a9.562,9.562,0,0,0,9.562-9.562Zm-9.3,0v9.82a.258.258,0,0,1-.259.259h-9.82a.259.259,0,0,1-.259-.258v-9.82a.26.26,0,0,1,.259-.258h9.82a.259.259,0,0,1,.259.258Z",
    transform: "translate(-170.384 -121.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    className: "cls-3",
    d: "M92.56,229.466A9.562,9.562,0,0,0,83,219.9H53.538a9.563,9.563,0,0,0-9.562,9.562v9.819a9.562,9.562,0,0,0,9.562,9.562H83a9.562,9.562,0,0,0,9.562-9.562Zm-9.3,0v9.82a.258.258,0,0,1-.259.258H53.538a.258.258,0,0,1-.258-.258v-9.82a.259.259,0,0,1,.258-.259H83a.259.259,0,0,1,.259.259Z",
    transform: "translate(-24.338 -121.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    className: "cls-3",
    d: "M92.561,317.429A9.561,9.561,0,0,0,83,307.867H53.538a9.561,9.561,0,0,0-9.562,9.562v9.82a9.562,9.562,0,0,0,9.562,9.562H83a9.562,9.562,0,0,0,9.562-9.562Zm-9.3,0v9.82a.26.26,0,0,1-.259.259H53.538a.259.259,0,0,1-.258-.259v-9.82a.258.258,0,0,1,.258-.259H83a.259.259,0,0,1,.259.259Z",
    transform: "translate(-24.338 -170.386)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyecto);
export default __webpack_public_path__ + "static/media/Proyecto.d361d351ce98e30c395f49e98e30cfba.svg";
export { ForwardRef as ReactComponent };